import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../../homepage/header-banner/TopNavButton';
import styled from 'styled-components';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import '../../microservice/container/sidebar.css';
import '../../Style/defaultstyle.css'
import CommonTable from '../../container/Table/Components/CommonTable';
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import config from '../../microservice/components/config-vn';
import Sidebar from '../../container/Sidebar/Sidebar';
import { useTranslation } from "react-i18next";

// add
import CardBox from '../../container/Box/Components/CardBox';
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard"
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute"
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import BanneServerApplication from '../../container/Banner/banner-serverApplication';
import DividerComponent from '../../container/Divider/divider';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import HeaderVn from '../../detailpageVN/Page/component/headervn';
import FooterVn from '../../detailpageVN/Page/component/footervn';


const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;

// Titlecloudcompute
function MSA3VN() {
    const { t } = useTranslation();
    const isMobile = useIsMobile();

    return (
        <Sysfont className='App'>
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("어플리케이션 통합과 서비스")} */}
                        <BoxContent>
                            <MuiGrid container spacing={3}>
                                <MuiGrid item xs={12} sm={12}>{CardBox(
                                    "<p class='typo-21 typo-medium typo-black'>Lợi ích của kiến trúc Microservices</p>",
                                    `<p class='typo-14'>Trong các ứng dụng được xây dựng theo kiến trúc microservices, các thành phần nhỏ được tách biệt và có thể hoạt động độc lập, đồng thời dễ dàng tương tác và tích hợp với nhau. 
                                    </p><br>
                                    <p class='typo-14'>Điều này cho phép doanh nghiệp phát triển nhanh hơn, dễ dàng cập nhật hoặc bổ sung tính năng mới mà không ảnh hưởng đến toàn bộ hệ thống. Nhờ đó, việc cập nhật, xử lý lỗi và vận hành trở nên linh hoạt hơn, giúp doanh nghiệp tiết kiệm thời gian và nguồn lực.</p>`
                                )}
                                </MuiGrid>
                                <DividerComponent />
                                <MuiGrid item xs={12} sm={12}>{CardBox(
                                    "<p class='typo-21 typo-medium typo-black'>Dịch vụ API và kiến trúc serverless</p>",
                                    `<p class='typo-14'>Đây là các dịch vụ cho phép ứng dụng, lưu trữ dữ liệu và cơ sở dữ liệu được vận hành trên nền tảng đám mây, thay vì phải quản lý máy chủ riêng. Bạn chỉ cần đăng ký sử dụng dịch vụ cloud theo nhu cầu và trả phí theo mức độ sử dụng thực tế. 
                                    </p></br>
                                    <p class='typo-14'>Dịch vụ này thường có tính mở, hỗ trợ phát triển ứng dụng phân tán mà không cần lập trình thủ công phức tạp, giúp tiết kiệm thời gian và giảm tải công việc cho các nhà phát triển.</p>`
                                )}
                                </MuiGrid>
                                <DividerComponent />
                                {/*
                                <MuiGrid item xs={12}>{Imagecloudcompute("https://www.hanbiro.com/cloud/library2/cluster-cloud-postgresql-db/postgresql_cluster.svg")}</MuiGrid>
                                */}
                            </MuiGrid>
                            {/* <Boxtitle className='MuiTypography-root MuiTypography-h6 sub-title normal css-y5btr1-MuiTypography-root'>{t('msa_3.line_5')}</Boxtitle> */}
                            <Boxtitle className='MuiTypography-root MuiTypography-h6 sub-title normal css-y5btr1-MuiTypography-root'>Dịch vụ ứng dụng / Dịch vụ dạng serverless / Thư viện</Boxtitle>
                            <CommonTable header={config.tb1_header} content={config.tb1_content} />
                        </BoxContent>

                        {/* <CloudConsultCp /> */}
                    </Col>

                </Row>
            </Container>
            <FooterVn />
        </Sysfont>
    );
};


const MuiGrid = styled.div`
    padding: 0px,
`

const BoxContent = styled.div`
    ${'' /* box-shadow: 0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 4px;
    margin-top: 20px;
    margin-bottom: 20px; */}
    text-align: left;
`
const SmallBox = styled.div`
    ${'' /* border: 1px solid #E7EAF3;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    margin-top: 20px; */}
    text-align: left;
`

const Boxtitle = styled.div`
    margin: 20px 5px;
    font-weight: bold;
`


const BoxText = styled.div`
    margin: 20px 5px;
    
`

export default MSA3VN;